// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__12oUb","main-image":"Header_main-image__2ZZWx"};